import { TaskName } from './TaskName';

export default TaskName;
